import { Navigate, Outlet, useLocation } from 'react-router';

import { LoadingOverlay } from '@/components/common/LoadingOverlay';
import { useAuth } from '@/features/auth/hooks/useAuth';

/**
 * Gate for any route that requires a signed-in user. Renders nothing but
 * a full-screen loader while the auth store is still hydrating from
 * storage (`isInitializing`), so an authenticated user is never bounced
 * to `/login` by a false-negative on first paint.
 */
export function ProtectedRoute() {
  const { isAuthenticated, isInitializing } = useAuth();
  const location = useLocation();

  if (isInitializing) {
    return <LoadingOverlay />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
